import React from 'react';
import { Link } from 'react-router-dom';
import { siteConfig } from '../assets/config';
import './Terms.css';

const Terms = () => {
  return (
    <div className="terms-page">
      {/* Hero Section */}
      <section className="terms-hero">
        <div className="container">
          <div className="terms-hero-content">
            <h1>Terms of Service</h1>
            <p>Our terms and conditions for using our services</p>
          </div>
        </div>
      </section>

      {/* Terms Content */}
      <section className="section terms-content">
        <div className="container">
          <div className="terms-content-wrapper">
            <div className="last-updated">
              <p><strong>Last Updated:</strong> {new Date().toLocaleDateString()}</p>
            </div>

            <div className="terms-section">
              <h2>1. Acceptance of Terms</h2>
              <p>
                By accessing and using the Musespace website at {siteConfig.domain || 'musespace.in'} and our services, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
              </p>
            </div>

            <div className="terms-section">
              <h2>2. Description of Service</h2>
              <p>
                Musespace provides architecture and interior design services, including but not limited to:
              </p>
              <ul>
                <li>Architectural design and planning</li>
                <li>Interior design and decoration</li>
                <li>Space planning and optimization</li>
                <li>Project management and coordination</li>
                <li>Consultation and advisory services</li>
                <li>3D visualization and rendering</li>
              </ul>
            </div>

            <div className="terms-section">
              <h2>3. User Responsibilities</h2>
              <p>As a user of our services, you agree to:</p>
              <ul>
                <li>Provide accurate and complete information</li>
                <li>Maintain the security of your account information</li>
                <li>Use our services for lawful purposes only</li>
                <li>Respect intellectual property rights</li>
                <li>Not interfere with the proper functioning of our website</li>
                <li>Not attempt to gain unauthorized access to our systems</li>
              </ul>
            </div>

            <div className="terms-section">
              <h2>4. Intellectual Property Rights</h2>
              <p>
                All content on this website, including but not limited to text, graphics, logos, images, audio clips, digital downloads, data compilations, and software, is the property of Musespace or its content suppliers and is protected by international copyright laws.
              </p>
              <p>
                You may not reproduce, distribute, modify, create derivative works of, publicly display, publicly perform, republish, download, store, or transmit any of the material on our website, except as follows:
              </p>
              <ul>
                <li>Your computer may temporarily store copies of such materials in RAM incidental to your accessing and viewing those materials</li>
                <li>You may store files that are automatically cached by your Web browser for display enhancement purposes</li>
                <li>You may print or download one copy of a reasonable number of pages of the website for your own personal, non-commercial use</li>
              </ul>
            </div>

            <div className="terms-section">
              <h2>5. Service Agreements</h2>
              <p>
                When you engage our services, additional terms and conditions may apply. These will be provided in a separate service agreement that will govern the specific project or service.
              </p>
              <h3>5.1 Project Terms</h3>
              <ul>
                <li>Project scope and deliverables will be defined in writing</li>
                <li>Timelines and milestones will be agreed upon in advance</li>
                <li>Payment terms and schedules will be clearly outlined</li>
                <li>Revision policies and limitations will be specified</li>
              </ul>
            </div>

            <div className="terms-section">
              <h2>6. Payment and Billing</h2>
              <p>
                Payment terms for our services will be outlined in individual service agreements. Generally:
              </p>
              <ul>
                <li>Payment schedules will be agreed upon before project commencement</li>
                <li>Late payments may incur additional charges</li>
                <li>All fees are non-refundable unless otherwise specified</li>
                <li>We reserve the right to suspend services for non-payment</li>
              </ul>
            </div>

            <div className="terms-section">
              <h2>7. Limitation of Liability</h2>
              <p>
                To the fullest extent permitted by applicable law, Musespace shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from:
              </p>
              <ul>
                <li>Your use or inability to use our services</li>
                <li>Any unauthorized access to or use of our servers</li>
                <li>Any interruption or cessation of transmission to or from our services</li>
                <li>Any bugs, viruses, or other harmful code that may be transmitted through our services</li>
                <li>Any errors or omissions in any content or for any loss or damage incurred as a result of the use of any content</li>
              </ul>
            </div>

            <div className="terms-section">
              <h2>8. Disclaimers</h2>
              <p>
                Our services are provided "as is" and "as available" without any warranties of any kind, either express or implied, including but not limited to:
              </p>
              <ul>
                <li>Warranties of merchantability</li>
                <li>Fitness for a particular purpose</li>
                <li>Non-infringement</li>
                <li>Accuracy or completeness of information</li>
              </ul>
              <p>
                We do not warrant that our services will be uninterrupted, secure, or error-free.
              </p>
            </div>

            <div className="terms-section">
              <h2>9. Privacy and Data Protection</h2>
              <p>
                Your privacy is important to us. Please review our Privacy Policy, which also governs your use of our services, to understand our practices regarding the collection and use of your personal information.
              </p>
            </div>

            <div className="terms-section">
              <h2>10. Termination</h2>
              <p>
                We may terminate or suspend your access to our services immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.
              </p>
              <p>
                Upon termination, your right to use our services will cease immediately. If you wish to terminate your account, you may simply discontinue using our services.
              </p>
            </div>

            <div className="terms-section">
              <h2>11. Governing Law</h2>
              <p>
                These Terms shall be interpreted and governed by the laws of India, without regard to its conflict of law provisions. Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights.
              </p>
            </div>

            <div className="terms-section">
              <h2>12. Changes to Terms</h2>
              <p>
                We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will try to provide at least 30 days notice prior to any new terms taking effect.
              </p>
              <p>
                What constitutes a material change will be determined at our sole discretion. By continuing to access or use our services after any revisions become effective, you agree to be bound by the revised terms.
              </p>
            </div>

            <div className="terms-section">
              <h2>13. Contact Information</h2>
              <p>If you have any questions about these Terms of Service, please contact us:</p>
              <div className="contact-info">
                <p><strong>Email:</strong> <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a></p>
                <p><strong>Phone:</strong> <a href={`tel:${siteConfig.contact.phone}`}>{siteConfig.contact.phone}</a></p>
                <p><strong>Address:</strong> {siteConfig.contact.address}</p>
              </div>
            </div>

            <div className="terms-links">
              <Link to="/privacy" className="btn btn-secondary">Privacy Policy</Link>
              <Link to="/" className="btn btn-primary">Back to Home</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms; 